import { Col, Divider, Row, Typography } from "antd";
import useCapitalize from "apps/Common/Adress/helpers/useCapitalize";
import { useGetCategoryTreeById,useGetCategoryByFilter } from "apps/RealState/ListItems/ServerSideStates";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

const CategoryList: FC<{ categoryId: any }> = ({ categoryId }) => {
  console.log("categoryId", categoryId);
  // if(categoryId === 1){
  //   categoryId = "vasita"
  // }else{
  //   categoryId = "gayrimenkul"
  // }
  const categories = useGetCategoryByFilter(categoryId);
  
  const { Text } = Typography;
  const {capitalize} = useCapitalize()
  const navigate = useNavigate()
  return (
    <Row gutter={[20, 0]}>
      <Col xs={24} className="!pb-2 cursor-pointer "
       onClick={()=>{
        const url = `/ilan/${categoryId==="gayrimenkul"  ? "gayrimenkul" : "vasita"}`;
         navigate(url);
   }}
      >
        <Text className="!text-[#333333] !text-lg ">
          {categoryId === "gayrimenkul" ? "Gayrimenkul" : "Vasıta"}
        </Text>
      </Col>
      <Col xs={24}>
        <Divider className="!m-0" />
      </Col>
      {categories?.data?.data?.subCategories?.map((category: any) => {
        return (
          <>
            <Col xs={24} className="cursor-pointer !py-4" onClick={()=>{
                 const url = `/ilan/${
                    category?.url
                  }`;
                  navigate(url);
            }} >
              <span className="!text-[#003399] !text-sm" >
               {capitalize( category.name)}
                <span className="!text-xs !text-gray-400">
                  ({category.advertCount})
                </span>
              </span>
            </Col>
            <Col xs={24} >
            <Divider className="!m-0" />
            </Col>
          </>
        );
      })}
    </Row>
  );
};

export default CategoryList;

